module.exports = __webpack_public_path__ + "media/images/athletes/1425-f72e6149c3f77d01cf23f96a673eef05.png";